<script>
    export let routes;
    let path = document.location.pathname;
    console.log('Oh no', path)
    
    const matches = [...routes.entries()]
        .map(([ regex, callback ]) => {
            if (regex.startsWith('/')) {
                regex = `\\/?${regex.slice(1)}`;
            } else {
                regex = `\\/?${regex}`;
            }
            const regexp = new RegExp(`^${regex}$`)
            let match = path.match(regexp);
            console.log('Oh no', JSON.stringify(path), 'with', match, '|', regexp.test(path), '|', regexp);
            if (match) {
                match = match.slice(1);
            }
            return {
                match, callback
            }
        });
    
    let Component;
    let params;
    
    for (const { match, callback } of matches) {
        if (match) {
            params = match;
            Component = callback();
            break;
        }
    }
    </script>
    
{#if params.length > 0}
    <svelte:component this={Component} {params} />
{:else}
    <svelte:component this={Component} />
{/if}